import { graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import formatMoney from '../utils/formatMoney';

const DropdownWrapper = styled.div`
  display: inline-block;
  padding: 40px 32px 40px 0px;
`;

const Dropdown = styled.select`
  display: inline-block;
  padding: 10px;
  background: var(--light-grey);
  font-weight: 700;
  border: none;
  outline: none;
`;

const DropdownOption = styled.option`
  padding: 10px;
  background: var(--light-grey);
  font-weight: 700;
  border: none;
  outline: none;
`;

const BuyButton = styled.button`
  padding: 40px;
  width: 95%;
  background: var(--main-brand);
  font-weight: 700;
  color: var(--taupe);
`;

const ImageWrapper = styled.div`
  display: inline-block;
  min-width: 280px;
  max-width: 500px;
  padding-left: 32px;
`;

const DNPWrapper = styled.div`
  display: inline-block;
  width: 300px;
  vertical-align: bottom;
  padding-left: 32px;
`;

const NameWrapper = styled.div`
  display: inline-block;
  vertical-align: bottom;
  padding: 20px 0;
`;

const DescriptionWrapper = styled.div`
  display: inline-block;
  vertical-align: bottom;
  padding: 20px 0;
`;

const PriceWrapper = styled.div`
  display: inline-block;
  vertical-align: bottom;
  padding-top: 20px;
`;

const ModsButtonsWrapper = styled.div`
  padding-left: 32px;
  max-width: 900px;
`;

const BuyButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  width: 100%;
`;

export default function SingleItemPage({ data }) {
  // Setting constants:
  const item = data.item;
  const stonesList = data.item.stones.stonesArray;
  let price = item.price / 100;
  price = price.toFixed(2);
  const image = getImage(item.image.asset.gatsbyImageData);

  setInitialValues(item);
  // Now we're going to build our states (values) for our dropdown menus. This sets the default values:
  function setInitialValues(item) {
    if (item.numModArray || item.wordModArray) {
      let initialValues = {};
      item.numModArray.map(function (element) {
        initialValues[element.computerName] = element.defaultValue;
      });
      item.wordModArray.map(function (element) {
        initialValues[element.computerName] = element.defaultValue;
      });

      initialValues['stoneValue'] = item.stones.stonesArray[0].name;
      return initialValues;
    }
  }
  // Then we set the initial state:
  const [values, setValues] = useState(setInitialValues(item));

  // Then we handle any changes made by the user:
  const handleInputChange = e => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  // NEW STUFF:
  // We need to pull numModArray and wordModArray from the graphQL query and use them to load our dropdowns.
  function NumMods({ item }) {
    return item.numModArray.map(function (element) {
      let dropdownValue = element.computerName;

      return (
        <DropdownWrapper>
          {`${element.humanName}: `}
          <Dropdown
            name={dropdownValue}
            label={element.humanName}
            value={values[dropdownValue]}
            onChange={handleInputChange}
          >
            {element.valueArray.map(function (value, index) {
              return <DropdownOption key={index}>{value}</DropdownOption>;
            })}
          </Dropdown>
        </DropdownWrapper>
      );
    });
  }

  function WordMods({ item }) {
    return item.wordModArray.map(function (element) {
      let dropdownValue = element.computerName;

      return (
        <DropdownWrapper>
          {`${element.humanName}: `}
          <Dropdown
            name={dropdownValue}
            label={element.humanName}
            value={values[dropdownValue]}
            onChange={handleInputChange}
          >
            {element.valueArray.map(function (value, index) {
              return <DropdownOption key={index}>{value}</DropdownOption>;
            })}
          </Dropdown>
        </DropdownWrapper>
      );
    });
  }

  function Stone({ stones }) {
    // Returns a Select that displays possible stones
    return (
      <DropdownWrapper>
        {`Stone: `}
        <Dropdown
          name="stoneValue"
          label="Stone Options"
          value={values.stoneValue}
          onChange={handleInputChange}
        >
          {stones.map(function (element, index) {
            return <DropdownOption key={index}>{element.name}</DropdownOption>;
          })}
        </Dropdown>
      </DropdownWrapper>
    );
  }

  function BuildBuyButton({ item }) {
    let snipCartData = {};
    let tempObject = {};
    let tempObjectTwo = {};

    // Builds the standard, hardcoded snipcart data fields:
    snipCartData['className'] = 'snipcart-add-item';
    snipCartData['data-item-id'] = item.id;
    snipCartData['data-item-price'] = price;
    snipCartData['data-item-name'] = item.name;
    snipCartData['data-item-description'] = item.description;
    snipCartData['data-item-image'] = item.image.asset.url;
    snipCartData['data-item-url'] =
      'https://ceramoni-gatsby.netlify.app/browse/' + item.slug.current;

    // Builds the dynamic snipcart data (the "data-item-custom[x]" fields) for the numMods:
    item.numModArray.map(function (numMod) {
      tempObject[numMod.humanName] = numMod.computerName;
    });
    Object.keys(tempObject).map(function (humanName, index) {
      let computerName = tempObject[humanName];
      snipCartData['data-item-custom' + (index + 1) + '-name'] = humanName;
      snipCartData['data-item-custom' + (index + 1) + '-value'] =
        values[computerName];
      // Index lets us know where to start when we do this for wordMods.
      snipCartData['index'] = index + 1;
    });

    // Builds snipcart data for wordMods:
    item.wordModArray.map(function (wordMod) {
      tempObjectTwo[wordMod.humanName] = wordMod.computerName;
    });
    Object.keys(tempObjectTwo).map(function (humanName, index) {
      let computerName = tempObjectTwo[humanName];
      snipCartData[
        'data-item-custom' + (index + snipCartData.index + 1) + '-name'
      ] = humanName;
      snipCartData[
        'data-item-custom' + (index + snipCartData.index + 1) + '-value'
      ] = values[computerName];

      snipCartData['index'] = snipCartData.index + 1;
    });
    // Add the stones modifier:
    snipCartData['data-item-custom' + (snipCartData.index + 1) + '-name'] =
      'Stone';
    snipCartData['data-item-custom' + (snipCartData.index + 1) + '-value'] =
      values.stoneValue;
    delete snipCartData.index;

    return <BuyButton {...snipCartData}>Add to Cart</BuyButton>;
  }

  // *** Main return() statement comes next ***

  return (
    <Layout>
      <ImageWrapper>
        <GatsbyImage
          image={image}
          alt={`A picture of a ${item.name}`}
          style={{ borderRadius: 2 }}
        />
      </ImageWrapper>
      <DNPWrapper>
        <NameWrapper>{item.name}</NameWrapper>
        <DescriptionWrapper>{item.description}</DescriptionWrapper>
        <PriceWrapper>{formatMoney(item.price)}</PriceWrapper>
      </DNPWrapper>
      <form>
        <ModsButtonsWrapper>
          <NumMods item={item} />
          <WordMods item={item} />
          <Stone stones={stonesList} />
        </ModsButtonsWrapper>
        <BuyButtonWrapper>
          <BuildBuyButton item={item} />
        </BuyButtonWrapper>
      </form>
    </Layout>
  );
}

// Now all that's left is the Graphql query:

export const query = graphql`
  query ($slug: String!) {
    item: sanityItem(slug: { current: { eq: $slug } }) {
      description
      id
      image {
        asset {
          gatsbyImageData
        }
      }
      name

      numModArray {
        computerName
        defaultValue
        humanName
        valueArray
      }
      price
      slug {
        current
      }
      stones {
        stonesArray {
          description
          id
          name
          chakra
        }
      }
      wordModArray {
        computerName
        defaultValue
        humanName
        valueArray
      }
    }
  }
`;
